import { createSelector } from 'reselect';

const getTasks      = (state)  => state.task.entities;

const getTasksThatNeedPlanning = createSelector(
    [getTasks],
    (tasks) => {

        let allTasks = tasks.allIds.map(taskId => tasks.byId[taskId]);

        return allTasks
        .filter((task, index) => !task.date)
        .sort((a, b) =>  a.homework_id - b.homework_id || a.order - b.order)
        .reverse();
    }
);

export default getTasksThatNeedPlanning;
